"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setInstanceId = exports.sendTags = exports.getCampaignDetailsSuccess = exports.getCampaignDetailsFail = exports.getCampaignDetails = exports.CONSTANTS = exports.CALL_TEALIUM = void 0;
var _appConstants = require("../appConstants");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CALL_TEALIUM = 'CALL_TEALIUM';
exports.CALL_TEALIUM = CALL_TEALIUM;
var sendTags = function sendTags(taggingValue, taggingType) {
  return {
    type: CALL_TEALIUM,
    payload: {
      taggingValue: taggingValue,
      taggingType: taggingType
    }
  };
};
exports.sendTags = sendTags;
var constants = {
  SET_INSTANCE_ID: 'SET_INSTANCE_ID',
  GET_CAMPAIGN_DETAILS: 'GET_CAMPAIGN_DETAILS',
  GET_CAMPAIGN_DETAILS_SUCCESS: 'GET_CAMPAIGN_DETAILS/SUCCESS',
  GET_CAMPAIGN_DETAILS_FAIL: 'GET_CAMPAIGN_DETAILS/FAIL'
};
var CONSTANTS = Object.keys(constants).map(function (key) {
  return _defineProperty({}, key, "@".concat(_appConstants.pkgName, "/").concat(constants[key]));
}).reduce(function (acc, item) {
  return Object.assign(acc, _objectSpread({}, item));
}, {});
exports.CONSTANTS = CONSTANTS;
var setInstanceId = function setInstanceId(payload) {
  return {
    type: CONSTANTS.SET_INSTANCE_ID,
    payload: payload
  };
};
exports.setInstanceId = setInstanceId;
var getCampaignDetails = function getCampaignDetails(payload) {
  return {
    type: CONSTANTS.GET_CAMPAIGN_DETAILS,
    payload: payload
  };
};
exports.getCampaignDetails = getCampaignDetails;
var getCampaignDetailsSuccess = function getCampaignDetailsSuccess(payload) {
  return {
    type: CONSTANTS.GET_CAMPAIGN_DETAILS_SUCCESS,
    payload: payload
  };
};
exports.getCampaignDetailsSuccess = getCampaignDetailsSuccess;
var getCampaignDetailsFail = function getCampaignDetailsFail() {
  return {
    type: CONSTANTS.GET_CAMPAIGN_DETAILS_FAIL
  };
};
exports.getCampaignDetailsFail = getCampaignDetailsFail;